import React from "react"

import { Heading, Text } from "@chakra-ui/react"

import RegisterConfirm from "@/components/RegisterConfirm"
import Message from "@/components/Message"
import AccountLayout from "@/components/AccountLayout"

export default function RegisterConfirmView() {
  const gradientBox = <RegisterConfirm />

  const message = (
    <Message>
      <Heading variant="standardSub">
        Thank you for signing up for Blind Insight!
      </Heading>
      <Text variant="base">
        Please check your email for an activation link!
      </Text>
    </Message>
  )
  return <AccountLayout gradientBox={gradientBox} message={message} />
}
